import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-shield-star-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-800">
                健康性知识平台
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              致力于提供安全、科学、健康的性教育知识与资讯，帮助用户理性看待成人内容，保护个人隐私与网络安全。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/category/sex-education"
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
                >
                  性教育科普
                </Link>
              </li>
              <li>
                <Link
                  to="/category/healthy-knowledge"
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
                >
                  健康性知识
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-foreground-400"></i>
                <span>contact@health-edu.cn</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-foreground-400"></i>
                <span>400-123-4567</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-foreground-400"></i>
                <span>中国北京市朝阳区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 健康性知识平台 版权所有 | ICP备案号：京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors" rel="nofollow">
              使用条款
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}